export default __webpack_public_path__ + "static/media/femimed_gabinet_3_thumbnail.339aeb65.webp";